exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-team-select {\n  width: 15rem; }\n  app-team-select button mat-icon.close-icon {\n    width: 100% !important;\n    height: 100% !important;\n    opacity: 0.7; }\n  app-team-select mat-form-field {\n    width: auto; }\n    app-team-select mat-form-field mat-label {\n      color: white; }\n\ninput.mat-input-element {\n  caret-color: white; }\n", ""]);

// exports
